export default __webpack_public_path__ + "static/media/laptop-phone.7e2ed831.svg";